// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1w1IZ","row":"Node_row__1j8f4","label":"Node_label__2b5Hg","footer":"Node_footer__3LzIV"};